import company from "../assets/images/projects/company.PNG";
import ecommerce from "../assets/images/projects/ecommerce.PNG";
import youtuby from "../assets/images/projects/youtuby.PNG";
import agency from "../assets/images/projects/agency.PNG";
import mobileApp from "../assets/images/projects/mobile-app.PNG";
import product from "../assets/images/projects/product.PNG";
import modernBank from "../assets/images/projects/bank.PNG";
import bootstrap from "../assets/images/projects/bootstrap.PNG";
import prayerTimes from "../assets/images/projects/prayer-time.PNG";
import flightBooking from "../assets/images/projects/flight-booking.PNG";

const projectsData = [
  {
    id: 1,
    title: "flight booking",
    coverImg: flightBooking,
    usedSkills: ["React.js", "Tailwind.css", "Redux-Toolkit"],
    for: "Hands-On Learning",
    date: "Jun 8, 2024",
    pageLink: "https://booking-a-ticket.netlify.app/",
    githubRepoLink: "https://github.com/moabdalaziz1/Booking-A-Ticket",
  },
  {
    id: 2,
    title: "prayer times",
    coverImg: prayerTimes,
    usedSkills: ["React.js", "MaterialUi"],
    for: "Hands-On Learning",
    date: "Feb 1, 2024",
    pageLink: "https://p-t-11.netlify.app/",
    githubRepoLink: "https://github.com/moabdalaziz1/Prayer-Times",
  },
  {
    id: 3,
    title: "AR landing page",
    coverImg: bootstrap,
    usedSkills: ["HTML", "CSS3", "Bootstrap"],
    for: "Freelance Client via Upwork",
    date: "May 6, 2023",
    pageLink: "https://bootstrap-website-11.netlify.app/",
    githubRepoLink: "https://github.com/moabdalaziz1/Bootstrap-website",
  },
  {
    id: 4,
    title: "modern bank",
    coverImg: modernBank,
    usedSkills: ["React.js", "Tailwind.css"],
    for: "Hands-On Learning",
    date: "Mar 19, 2023",
    pageLink: "https://modern-bank-11.netlify.app/",
    githubRepoLink: "https://github.com/moabdalaziz1/modern_bank_app",
  },
  {
    id: 5,
    title: "company website",
    coverImg: company,
    usedSkills: ["HTML5", "SASS", "Javascript", "Bootstrap5", "Webpack"],
    for: "Hsoub Certification Projects",
    date: "Dec 31, 2021",
    pageLink: "https://company-website11.netlify.app/",
    githubRepoLink: "https://github.com/moabdalaziz1/The-Company-Project",
  },
  {
    id: 6,
    title: "e-commerce",
    coverImg: ecommerce,
    usedSkills: ["HTML5", "SASS", "Javascript", "Bootstrap5", "Webpack"],
    for: "Hsoub Certification Projects",
    date: "Dec 11, 2021",
    pageLink: "https://11ecommerce11.netlify.app/",
    githubRepoLink: "https://github.com/moabdalaziz1/e-commerce",
  },
  {
    id: 7,
    title: "youtuby",
    coverImg: youtuby,
    usedSkills: ["HTML5", "CSS3", "Javascript", "Bootstrap5"],
    for: "Hsoub Certification Projects",
    date: "Nov 30, 2021",
    pageLink: "https://youtuby11.netlify.app/",
    githubRepoLink: "https://github.com/moabdalaziz1/Youtuby",
  },
  {
    id: 8,
    title: "LP agency",
    coverImg: agency,
    usedSkills: ["HTML5", "CSS3", "Javascript", "Bootstrap5"],
    for: "Hsoub Certification Projects",
    date: "Sep 23, 2021",
    pageLink: "https://11agency11.netlify.app/",
    githubRepoLink: "https://github.com/moabdalaziz1/Company-Page",
  },
  {
    id: 9,
    title: "LP mobile app",
    coverImg: mobileApp,
    usedSkills: ["HTML5", "CSS3", "Javascript", "Bootstrap5"],
    for: "Hsoub Certification Projects",
    date: "Aug 17, 2021",
    pageLink: "https://mobile-app11.netlify.app/",
    githubRepoLink: "https://github.com/moabdalaziz1/Mobile-App-Page",
  },
  {
    id: 10,
    title: "LP product",
    coverImg: product,
    usedSkills: ["HTML5", "CSS3", "Javascript", "Bootstrap5"],
    for: "Hsoub Certification Projects",
    date: "July 9, 2021",
    pageLink: "https://11product11.netlify.app/",
    githubRepoLink: "https://github.com/moabdalaziz1/Product-Page",
  },
];

export default projectsData;
